import { JsonObject, JsonProperty } from 'json2typescript';
import { OptionInterface } from './../interfaces/option.interface';

@JsonObject('OptionModel')
export class OptionModel implements OptionInterface {
  @JsonProperty('Description', String, true)
  description: string = undefined;

  @JsonProperty('ExtendedValue', String, true)
  extendedType: string = undefined;

  @JsonProperty('extendedValue', String, true)
  extendedValue: string = undefined;

  @JsonProperty('Id', Number, true)
  id: number = undefined;

  @JsonProperty('IsDisabled', Boolean, true)
  isDisabled: boolean = false;

  @JsonProperty('ListOptionDisable', String, true)
  listOptionDisable: string = undefined;

  @JsonProperty('ListQuestionDisable', String, true)
  listQuestionDisable: string = undefined;

  @JsonProperty('Order', Number, true)
  order: number = undefined;
}
